// extracted by mini-css-extract-plugin
export default {"slider":"index_slider_ja4Il","big_pic":"index_big_pic_paXGu","title":"index_title_E4NBy","dot":"index_dot_jcHXz","current":"index_current_hwZ-t","trans":"index_trans_0McVN"};